module.exports = [
  '$scope',
  '$state',
  '$uibModal',
  '$q',
  'toastService',
  'situationRecordService',
  'situationRecordClass',
  'translateFilter',
  'zonedDateTimeToDateFilter',
  'utilsService',
  '$http',
  function (
    $scope,
    $state,
    $uibModal,
    $q,
    toastService,
    situationRecordService,
    situationRecordClass,
    translateFilter,
    zonedDateTimeToDateFilter,
    utilsService,
    $http
  ) {
    var ctrl = this;

    //*******************************************************************
    //********************        ORDINAMENTO TABELLA        ************
    //*******************************************************************
    var defaultTableOrder = {
      //field: 'createdDate',
      field: 'createdUpdateDate',
      reverseSort: false,
    };

    ctrl.order = function (field) {
      if (field) {
        ctrl.tableOrder.reverseSort =
          ctrl.tableOrder.field === field ? !ctrl.tableOrder.reverseSort : false;
        ctrl.tableOrder.field = field;
      }
    };

    $scope.$watch('situationRecordList', function (newVal) {
      if (newVal) {
        angular.forEach(newVal, function (sr) {
          situationRecordClass.getUpdatedDate(sr);
          situationRecordClass.getUpdatedBy(sr);
          situationRecordClass.getIsPublic(sr);
          situationRecordClass.getIsFuture(sr);
          situationRecordClass.getIsValid(sr);

          //                             Boolean ret = false;
          //        if (situationRecord != null && situationRecord.getConfidentiality() != null) {
          //            ret = situationRecord.getConfidentiality() == ConfidentialityValueEnum.NO_RESTRICTION;
          //        }
          //
          //        return ret;
        });

        ctrl.tableOrder = defaultTableOrder;
      }
    });

    //*********************************************************************
    //**************************GESTIONE EVENTI ****************************
    //*********************************************************************
    ctrl.openSituationRecord = function (situationRecord) {
      $state.go('situation-record-mgmt', {
        id: situationRecord.id,
        curSearchFilter: $scope.curFilter,
      });
    };

    ctrl.checkForEndValidity = function (situationRecord) {
      var mainConfig = global.ngDroAstralSituationRecordMainConfig;
      var baseEndPointUrl = mainConfig.ApiUrl;
      var situationRecordEndPointUrl = baseEndPointUrl + 'situation-record/';
      var url = situationRecordEndPointUrl + 'check-for-end-validity/:id';

      $http
        .get(url.replace(':id', situationRecord.id), { withCredentials: true })
        .then(function (res) {
          if (res && res.data === false) {
            var dialogInst = $uibModal.open({
              template: require('../../modal/modalQuest.html'),
              controller: 'modalQuestCtrl',
              size: 'md',
              resolve: {
                params: function () {
                  return {
                    headerMessage: translateFilter('AstralSituationRecord.attention'),
                    bodyMessage:
                      "L'evento contiene dei periodi di validità futuri. Sei sicuro di voler terminare l'evento  <b>" +
                      situationRecord.comments[1].comment +
                      '</b>?',
                    showCancelButton: true,
                    showYesButton: true,
                    cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
                    yesButtonText: translateFilter('AstralSituationRecord.yes'),
                  };
                },
              },
            });
            dialogInst.result.then(
              function () {
                ctrl.closeSituationRecord(situationRecord);
              },
              function () {}
            );
          } else {
            ctrl.closeSituationRecord(situationRecord);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    };

    ctrl.cloneSituationRecord = function (situationRecord) {
      situationRecordService.duplicate(
        { id: situationRecord.id },
        function (res) {
          $state.go('situation-record-new', {
            clonedSituationRecord: res,
            curSearchFilter: $scope.curFilter,
          });
        },
        function (res) {
          console.log(res);
        }
      );
    };

    ctrl.refreshSituationRecord = function (situationRecord) {
      situationRecordClass.formatCurSituationRecordDates(situationRecord);

      var dialogInst = $uibModal.open({
        template: require('../../modal/modalValidityPeriods.html'),
        controller: 'modalValidityPeriodsCtrl',
        size: 'md',
        resolve: {
          params: function () {
            return {
              situationRecord: situationRecord,
            };
          },
        },
      });
      dialogInst.result.then(
        function (result) {
          //updSituationRecord(situationRecord).then(function () {
          //sollevo l'evento
          $scope.situationRecordUpdated(situationRecord);
          //});
        },
        function (result) {
          if (result && result === utilsService.modalResults.saveError) {
            $scope.situationRecordUpdated(situationRecord);
          }
        }
      );
    };

    ctrl.broadcastSituationRecord = function (situationRecord) {
      var dialogInst = $uibModal.open({
        template: require('../../modal/modalChannels.html'),
        controller: 'modalChannelsCtrl',
        size: 'md',
        resolve: {
          situationRecord: function () {
            return situationRecord;
          },
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage:
                "Sei sicuro di voler pubblicare l'evento  <b>" +
                situationRecord.comments[1].comment +
                '</b>?',
              showCancelButton: true,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.yes'),
            };
          },
        },
      });

      dialogInst.result.then(
        function (result) {
          if (result) {
            situationRecordService.broadcast(
              {
                id: situationRecord.id,
              },
              result,
              function (res) {
                toastService.createSuccessToast('Notifica inviata correttamente');

                var srIdx = $scope.situationRecordList.findIndex(function (sr) {
                  return sr.id === situationRecord.id;
                });

                delete res.$promise;
                delete res.$resolved;

                $scope.situationRecordList[srIdx].channels = Object.values(res);
              },
              function (res) {
                console.log(res);

                toastService.createErrorToast("Errore durante l'invio della notifica");
              }
            );
          }
        },
        function () {}
      );
    };

    ctrl.closeSituationRecord = function (situationRecord) {
      var dialogInst = $uibModal.open({
        template: require('../../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'md',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage:
                "Sei sicuro di voler terminare l'evento  <b>" +
                situationRecord.comments[1].comment +
                '</b>?',
              showCancelButton: true,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.yes'),
            };
          },
        },
      });
      dialogInst.result.then(
        function () {
          situationRecordService.endValidity(
            { id: situationRecord.id },
            function (res) {
              $scope.situationRecordUpdated(situationRecord);
            },
            function (res) {
              console.log(res);
            }
          );
        },
        function () {}
      );
    };

    ctrl.deleteSituationRecord = function (situationRecord) {
      var dialogInst = $uibModal.open({
        template: require('../../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'sm',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage:
                translateFilter('AstralSituationRecord.deleteItemQuest') +
                ' Id:' +
                situationRecord.id,
              showCancelButton: true,
              showNoButton: false,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.ok'),
            };
          },
        },
      });
      dialogInst.result.then(
        function () {
          delSituationRecord(situationRecord.id).then(function () {
            //sollevo l'evento
            $scope.situationRecordDeleted(situationRecord);
          });
        },
        function () {}
      );
    };

    function delSituationRecord(id) {
      var deferred = $q.defer();
      if (id) {
        //verifico se ci sono situation records legati a questo (ome causa)
        var params = {
          page: 0,
          size: 1,
          sort: undefined,
        };
        var d1 = new Date();
        var filter = {
          clazz: situationRecordClass.getSituationRecordTypes().situationRecordFilter,
          validityPeriodsDateStart: new Date(1900, 1, 1, 0, 0, 0),
          validityPeriodsDateEnd: new Date(
            d1.getFullYear() + 10,
            d1.getMonth(),
            d1.getDate(),
            0,
            0,
            0
          ),
          topLeft: {
            x: -180,
            y: 90,
            z: null,
          },
          bottomRight: {
            x: 180,
            y: -90,
            z: null,
          },
          cause: id,
        };

        situationRecordService.search(
          params,
          filter,
          function (res) {
            if (res.totalElements) {
              //ci sono dei situation record legati al source che si cerca di cancellare --> ERRORE
              var error = {
                data: {
                  description: translateFilter(
                    'AstralSituationRecord.Error.situationRecordDelExistingSituationRecord'
                  ),
                },
              };

              deferred.reject(error);
            } else {
              //non ci sono dei situation record legati a quello che si cerca di cancellare --> ESEGUO CANCELLAZIONE
              situationRecordService.delete(
                { id: id },
                function (res) {
                  var msg = translateFilter('AstralSituationRecord.deleteSuccess');
                  toastService.createSuccessToast(msg);

                  deferred.resolve();
                },
                function (errors) {
                  errorHandler(errors);

                  deferred.reject();
                }
              );
            }
          },
          function (errors) {
            errorHandler(errors);

            deferred.reject();
          }
        );
      } else {
        toastService.createErrorToast(
          translateFilter('AstralSituationRecord.notValidParameter') + ': id'
        );

        deferred.reject();
      }

      return deferred.promise;
    }
    //*********************************************************************
    (function init() {
      ctrl.tableOrder = defaultTableOrder;
      ctrl.order(defaultTableOrder.field);
    })();
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/directives/situationRecordTable/situationRecordTableCtrl.js
// module id = 270
// module chunks = 0